"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TooltipContent = _interopRequireDefault(require("./TooltipContent"));

var _TooltipModule = _interopRequireDefault(require("./Tooltip.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var mountNode;

if (typeof window !== 'undefined') {
  mountNode = document.getElementById('ui-tooltips');

  if (!mountNode) {
    mountNode = document.createElement('div');
    mountNode.id = 'ui-tooltips';
    document.body.appendChild(mountNode);
  }
}

var Tooltip =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Tooltip, _PureComponent);

  function Tooltip() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Tooltip)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      shown: false
    };
    _this.triggerRef = _react.default.createRef();

    _this.startCloseTimer = function () {
      _this.closeTimer = setTimeout(_this.closeTooltip, _this.props.closeTimeout);
    };

    _this.closeTooltip = function () {
      _this.setState({
        shown: false
      }, _this.props.onClose);
    };

    _this.openTooltip = function () {
      _this.stopCloseTimer();

      _this.setState({
        shown: true
      }, _this.state.shown ? undefined : _this.props.onOpen);
    };

    return _this;
  }

  _createClass(Tooltip, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "stopCloseTimer",
    value: function stopCloseTimer() {
      clearTimeout(this.closeTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _React$cloneElement;

      var shown = this.state.shown;

      var _this$props = this.props,
          on = _this$props.on,
          trigger = _this$props.trigger,
          forwardedRefPropName = _this$props.forwardedRefPropName,
          passOpenStateAs = _this$props.passOpenStateAs,
          classes = _this$props.classes,
          El = _this$props.as,
          props = _objectWithoutProperties(_this$props, ["on", "trigger", "forwardedRefPropName", "passOpenStateAs", "classes", "as"]);

      var triggerEvent = on === 'click' ? 'onClick' : 'onMouseEnter';
      var ref = typeof trigger.type !== 'string' ? forwardedRefPropName : 'ref';
      var isFragment = El === _react.Fragment;

      var tooltip = _react.default.createElement(_TooltipContent.default, _extends({
        triggerRef: this.triggerRef,
        mountNode: mountNode,
        onMouseEnter: this.openTooltip,
        onMouseLeave: this.startCloseTimer,
        withCss: !isFragment
      }, props));

      var wrapperProps = isFragment ? undefined : {
        className: (0, _classnames.default)(_TooltipModule.default.wrapper, classes.wrapper)
      };
      var onMouseLeave = preserveUserHandler(this.startCloseTimer, trigger.props.onMouseLeave);
      var triggerEventHandler = preserveUserHandler(this.openTooltip, trigger.props[triggerEvent]);
      return _react.default.createElement(El, wrapperProps, _react.default.cloneElement(trigger, (_React$cloneElement = {}, _defineProperty(_React$cloneElement, ref, this.triggerRef), _defineProperty(_React$cloneElement, triggerEvent, triggerEventHandler), _defineProperty(_React$cloneElement, passOpenStateAs, passOpenStateAs ? shown : undefined), _defineProperty(_React$cloneElement, "onMouseLeave", onMouseLeave), _React$cloneElement)), shown ? isFragment ? _reactDom.default.createPortal(tooltip, document.body) : tooltip : null);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(_ref) {
      var shown = _ref.shown;

      if (typeof shown === 'undefined') {
        return null;
      }

      return {
        shown: shown
      };
    }
  }]);

  return Tooltip;
}(_react.PureComponent);

Tooltip.defaultProps = {
  on: 'hover',
  position: 'top',
  offsetX: 10,
  offsetY: 10,
  viewportOffset: 5,
  closeTimeout: 150,
  forwardedRefPropName: 'forwardedRef',
  align: 'center',
  classes: {},
  as: _react.Fragment,
  onOpen: function onOpen() {},
  onClose: function onClose() {}
};
process.env.NODE_ENV !== "production" ? Tooltip.propTypes = {
  on: _propTypes.default.oneOf(['click', 'hover']),
  position: _propTypes.default.oneOf(['top', 'right', 'bottom', 'left']),
  align: _propTypes.default.oneOf(['start', 'end', 'center']),
  offsetX: _propTypes.default.number,
  offsetY: _propTypes.default.number,
  closeTimeout: _propTypes.default.number,
  viewportOffset: _propTypes.default.number,
  trigger: _propTypes.default.node.isRequired,
  children: _propTypes.default.node.isRequired,

  /** Used for passing the `ref` when `trigger` has custom `forwardingRef` prop.
   E.g. <Link/> from `react-router-dom` has `innerRef` for forwarding refs*/
  forwardedRefPropName: _propTypes.default.string,

  /**
     Name of the prop, which will be passed to a trigger, containing tooltip shown state
     */
  passOpenStateAs: _propTypes.default.string,

  /**
     Class will be applied to the tooltip wrapper
   */
  className: _propTypes.default.string
} : void 0;

function preserveUserHandler(libHandler, userHandler) {
  return userHandler ? function () {
    libHandler.apply(void 0, arguments);
    userHandler.apply(void 0, arguments);
  } : libHandler;
}

var _default = Tooltip;
exports.default = _default;